import React from 'react';
import { useTheme } from '@emotion/react';
// Mui components
import { Modal, Typography, Backdrop, Fade, Button, Box } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// Components
import HorizontalDivider from '../../common/HorizontalDivider';
// Icons
import iconClose from '../../../assets/icons/icon_close.svg';

export default function ModalFiltrosSolicitudes({
  setClickFiltros,
  setFiltroRecienteAntigua,
  filtroRecienteAntigua,
  setFiltroStatus,
  filtroStatus,
  solicitudesPrestador,
  modalFiltroSolicitudesShow,
  handleClose,
  handleFilterSolicitudes
}) {
  const theme = useTheme();

  const filtroType = [
    { value: 'PENDIENTE', description: 'Solicitudes en análisis' },
    { value: 'APROBADO', description: 'Solicitudes aprobadas' },
    { value: 'RECHAZADO', description: 'Solicitudes rechazadas' },
    { value: 'ANULADO', description: 'Solicitudes anuladas' }
  ];

  const sortAndFilterSolicitudes = (solicitudes) => {
    if (solicitudes) {
      const filteredSolicitudes = solicitudes?.filter((solicitud) =>
        filtroStatus.includes(solicitud.status)
      );

      if (filtroRecienteAntigua) {
        filteredSolicitudes.sort((a, b) => {
          const fechaA = getMaxDate(a.fechaCreacion, a.fechaAlta, a.fechaBaja);
          const fechaB = getMaxDate(b.fechaCreacion, b.fechaAlta, b.fechaBaja);
          return fechaB - fechaA;
        });
      } else {
        filteredSolicitudes.sort((a, b) => {
          const fechaA = getMaxDate(a.fechaCreacion, a.fechaAlta, a.fechaBaja);
          const fechaB = getMaxDate(b.fechaCreacion, b.fechaAlta, b.fechaBaja);
          return fechaA - fechaB;
        });
      }

      return filteredSolicitudes;
    }
    return [];
  };

  const getMaxDate = (...dates) => {
    const validDates = dates.filter((date) => date);
    return validDates.length > 0 ? Math.max(...validDates) : null;
  };

  const handleOrderChange = (event) => {
    const selectedValue = event.target.value === 'recent';
    setFiltroRecienteAntigua(selectedValue);
  };

  const handleStatusChange = (event) => {
    const value = event.target.name;
    if (event.target.checked) {
      setFiltroStatus([...filtroStatus, value]);
    } else {
      setFiltroStatus(filtroStatus.filter((status) => status !== value));
    }
  };

  const handleCloseModal = () => {
    setFiltroStatus(['APROBADO', 'RECHAZADO', 'ANULADO', 'PENDIENTE']);
    setFiltroRecienteAntigua(true);
    handleClose();
  };

  const handleUseFiltro = () => {
    const updatedSolicitudes = sortAndFilterSolicitudes(solicitudesPrestador);
    handleFilterSolicitudes(updatedSolicitudes);
    setClickFiltros(true);
    handleClose();
  };


  const countResults = sortAndFilterSolicitudes(solicitudesPrestador || []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={modalFiltroSolicitudesShow}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}>
      <Fade in={modalFiltroSolicitudesShow}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: 608, sm: 608 },
            height: '25.6rem',
            bgcolor: 'white.main',
            borderRadius: '16px'
          }}>
          <Box
            sx={{
              display: 'flex',
              height: '3.5rem',
              width: '100%',
              borderBottom: `2px solid ${theme.palette.backgroundSecondary.main}`,
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
            <Typography variant="h4" sx={{ marginLeft: '40px' }}>
              Ordenar y filtrar
            </Typography>
            <Box
              component="img"
              sx={{ width: '24px', height: '24px', cursor: 'pointer', marginRight: '1rem' }}
              alt="img not found"
              src={iconClose}
              onClick={handleCloseModal}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '120px',
              flexDirection: 'column',
              width: '100%',
              padding: '16px 40px',
              gap: '12px'
            }}>
            <Typography variant="h4">Ordenar por</Typography>

            <RadioGroup
              aria-labelledby="consultorios-externos"
              name="radio-buttons-group"
              value={filtroRecienteAntigua ? 'recent' : 'oldest'}
              onChange={handleOrderChange}
              sx={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
              <FormControlLabel
                value="recent"
                control={<Radio />}
                sx={{ marginRight: '0' }}
                label={
                  <Typography variant="bodyS" sx={{ width: '14rem' }}>
                    Más reciente a más antigua
                  </Typography>
                }
              />
              <FormControlLabel
                value="oldest"
                control={<Radio />}
                sx={{ marginRight: '0' }}
                label={
                  <Typography variant="bodyS" sx={{ width: '14rem' }}>
                    Más antigua a más reciente
                  </Typography>
                }
              />
            </RadioGroup>
          </Box>
          <Box sx={{ padding: '0 40px' }}>
            <HorizontalDivider />
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '154px',
              flexDirection: 'column',
              justifyContent: 'space-around',
              width: '100%',
              padding: '16px 40px',
              gap: '12px'
            }}>
            <Typography variant="h4">Filtrar por</Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1rem'
              }}>
              {filtroType?.map((filtro) => {
                return (
                  <FormControlLabel
                    sx={{ marginLeft: '0', gap: '0.5rem' }}
                    control={
                      <Checkbox
                        sx={{ width: '1.5rem', height: '1.5rem' }}
                        checked={filtroStatus.includes(filtro.value)}
                        onChange={handleStatusChange}
                        name={filtro.value}
                      />
                    }
                    label={<Typography variant="bodyS">{filtro.description}</Typography>}
                    key={filtro.description}
                  />
                );
              })}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              padding: '16px 40px',
              justifyContent: 'center'
            }}>
            <Button
              onClick={handleUseFiltro}
              disabled={countResults.length === 0}
              sx={{ width: '19.75rem', height: '3rem', borderRadius: '1rem' }}
              variant="contained"
              color="primary">
              {countResults.length === 0
                ? 'No hay resultados'
                : `Ver ${countResults.length} resultados`}
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
